import React from 'react'
import { Image, Segment, Header } from 'semantic-ui-react'

const TagsMetric = (props) => (
    <Segment>
        <Header as='h2'>
            1. HOW DID YOU FEEL THIS WEEK?
        </Header>
        <p>
            This is a visualization of the types of the most intense emotions and feelings that you experienced in the 
            latest week of the program. Each quarter of the chart represents the four emotional categories you use to describe 
            your emotion; Distressed, Sad, Joyous, and Content. The size of each bubble relates to the frequency of use, of 
            the particular emotional tag, i.e., the bigger the bubble, the more often you felt that way.
        </p>
        <p>
            Tip: Choose an emotion to explore further by reviewing the journals associated with that emotion (see My Journal on the
            Feel App)!
        </p>
        <Header as='h3'>
            Your Emotion Map
        </Header>
        <Image src={`data:image/jpeg;base64,${props.tags_metric}`} alt={`${"tags.png"}`} centered/>
    </Segment>
)

export default TagsMetric



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/metrics/tags.js